@if (openWidget()) {
  <p-dialog
    [(visible)]="openWidget"
    [draggable]="true"
    [resizable]="false"
    [modal]="false"
    [style]="widgetStyle()"
    maskStyleClass="remove-modal-mask"
    position="top"
    styleClass="chat-widget-dialog"
    [appendTo]="appendTo()"
  >
    <ng-template pTemplate="header">
      <div class="flex w-full justify-content-between">
        <div>
          <app-button
            class="mr-auto"
            [icon]="!expandedView() ? PrimeIcons.CHEVRON_LEFT : PrimeIcons.CHEVRON_RIGHT"
            iconPos="left"
            styleClass="p-button-rounded p-button-text"
            (onClick)="expandedView.set(!expandedView())"
          ></app-button>
        </div>

        <div>
          <app-button
            class="ml-auto"
            [icon]="PrimeIcons.WINDOW_MAXIMIZE"
            iconPos="left"
            styleClass="p-button-rounded p-button-text"
            (onClick)="openWidgetInNewWindow()"
          ></app-button>
        </div>
      </div>
    </ng-template>

    @if (chatWidgetComponent()) {
      <ng-container
        *ngComponentOutlet="
          chatWidgetComponent();
          inputs: { preSelectionContext: contextForPreSelection(), mobileView: !expandedView() }
        "
      >
      </ng-container>
    }
  </p-dialog>
}
